import loadable from "@loadable/component";
import StatusIcon from "../../../Icons/StatusIcon";

const VehicleCategoryListComponent = loadable(
  () => import("../../../components/Settings/VehicleCategory/VehicleCategoryList")
);

const VehicleCategoryList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Vehicle Category</span>
      </div>
      <VehicleCategoryListComponent />
    </>
  );
};



export default VehicleCategoryList
